import { ViewResolver } from '@Components/ViewResolver';
import TodaySummaryDesktop from './desktop';
import TodaySummaryMobile from './mobile';

const TodaySummary: React.FC = () => {
  return (
    <ViewResolver
      desktop={<TodaySummaryDesktop />}
      mobile={<TodaySummaryMobile />}
    />
  );
};

export default TodaySummary;
